import { JobsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { jobsKeys } from 'app/queries/jobs/jobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.lockedStatusByRecordingId>>;

export const createFetchJobLockedStatusQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ recordingId }], signal }: TParams) =>
    call(() => cancelOnSignal(JobsService.getJobLockedStatusByRecordingId({ jobId: recordingId }), signal));
